export const grecianholiday = {
  name: 'Grecian Holiday',
  color: [0.12549019607843137, 0.5803921568627451, 0.5450980392156862, 1],
  bg: [0.1607843137254902, 0.5333333333333333, 0.7372549019607844, 1],
  grid1: [0.9568627450980393, 0.9176470588235294, 0.8705882352941177, 1],
  grid2: [0.9294117647058824, 0.5490196078431373, 0.4470588235294118, 1],
}
